/* __next_internal_client_entry_do_not_use__ ReactScanMonitoring auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { getReleaseSha } from "@faire/retailer-visitor-shared/serialized-data/getReleaseSha";
import { NoSSR } from "@faire/web--source/common/NoSSR";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Monitoring } from "react-scan/monitoring/next";
import { useSettingEnableReactScanMonitoring } from "@faire/retailer-visitor-shared/settings/useSettingEnableReactScanMonitoring";
export var ReactScanMonitoring = function(param) {
    var apiKey = param.apiKey;
    var enableReactScanMonitoring = useSettingEnableReactScanMonitoring();
    if (!enableReactScanMonitoring) {
        return null;
    }
    return /*#__PURE__*/ _jsx(NoSSR, {
        children: /*#__PURE__*/ _jsx(ErrorBoundary, {
            fallback: null,
            children: apiKey ? /*#__PURE__*/ _jsx(Monitoring, {
                apiKey: apiKey,
                commit: getReleaseSha(),
                branch: "_"
            }) : null
        })
    });
};
